import ApiClient from "../methods/api/apiClient";

/**
 * Le portfolio est activé pour une sous-famille de pro lorsque le champ
 * `portfolioRequired` (admin → Sous-famille de pro) vaut true.
 * On met en cache la liste publique des sous-familles pour éviter un appel
 * supplémentaire à chaque rendu.
 */
let subFamiliesCache = null;
let subFamiliesPromise = null;

const loadSubFamilies = () => {
  if (subFamiliesCache) return Promise.resolve(subFamiliesCache);
  if (!subFamiliesPromise) {
    subFamiliesPromise = ApiClient.get("pro-subfamily/listing")
      .then((res) => {
        subFamiliesCache = Array.isArray(res?.data) ? res.data : [];
        return subFamiliesCache;
      })
      .catch(() => [])
      .finally(() => {
        subFamiliesPromise = null;
      });
  }
  return subFamiliesPromise;
};

export const splitProSubFamilies = (value) =>
  String(value || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

/** Résout si la (les) sous-famille(s) du pro exige(nt) un portfolio. */
export const isPortfolioRequiredFor = async (proSubFamily) => {
  const names = splitProSubFamilies(proSubFamily);
  if (!names.length) return false;
  const rows = await loadSubFamilies();
  return rows.some(
    (row) => row.portfolioRequired === true && names.includes(row.name)
  );
};

export const resetPortfolioSubFamiliesCache = () => {
  subFamiliesCache = null;
  subFamiliesPromise = null;
};
